import { ComponentStylesWithFns } from '../../../theme/styles.helpers';

export const UserFormStyles: ComponentStylesWithFns = {
  root: {
    display: 'flex',
    height: '100%',
    width: '100%',
  },
  container: {
    height: '100%',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    boxSizing: 'border-box',
    overflowX: 'hidden',
    backgroundColor: 'primary.main',
    marginLeft: 5,
    borderRadius: '10px',
  },
  header: {
    display: 'flex',
    padding: 3,
    backgroundColor: 'white',
    borderBottom: '0.5px solid',
    borderColor: 'grey.200',
    justifyContent: 'center',
    alignItems: 'center',
  },
  headerTitle: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    flex: 1,
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    padding: '20px 30px',
    marginBottom: '20px',
    flexGrow: 1,
    maxHeight: 'calc(100% - 60px)',
    overflowY: 'auto',
    scrollbarColor: 'black #f6ebe4',
    scrollbarWidth: 'thin',
  },
  grid: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: 3,
  },
  gridItem: {
    display: 'inline-block',
    width: 'calc(50% - 10px)',
  },
  gridItem13: {
    display: 'inline-block',
    width: 'calc(20% - 10px)',
  },
  gridItem14: {
    display: 'inline-block',
    width: 'calc(25% - 10px)',
  },
  gridItem23: {
    display: 'inline-block',
    width: 'calc(40% - 10px)',
  },
  gridItem32: {
    display: 'inline-block',
    width: 'calc(80% - 10px)',
  },
  gridItemFull: {
    display: 'inline-block',
    width: '100%',
  },
};
